import type CargaItem from "../types/carga_item";
import { agruparItensPorEntrega, filtrarEntregas, ordenarEntregas } from "../utils/agruparEntregas";
import type { Entrega } from "../utils/agruparEntregas";
import EntregaCard from "./EntregaCard";

interface IProps {
  itens: CargaItem[];
  filtro: string;
  ordenarPor: "entrega" | "nota";
  onEntregar: (entrega: Entrega) => void;
}

const EntregaCardList = ({ itens, filtro, ordenarPor, onEntregar }: IProps) => {
  const entregas = ordenarEntregas(filtrarEntregas(agruparItensPorEntrega(itens), filtro), ordenarPor);

  return (
    <>
      {entregas.map((entrega) => (
        <EntregaCard key={entrega.chave} entrega={entrega} onEntregar={() => onEntregar(entrega)} />
      ))}
    </>
  )
}

export default EntregaCardList;
